"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RatingReviewData", {
  enumerable: true,
  get: function () {
    return _ReviewDisplay.RatingReviewData;
  }
});
Object.defineProperty(exports, "RatingSummary", {
  enumerable: true,
  get: function () {
    return _RatingSummary.RatingSummaryWithTracking;
  }
});
Object.defineProperty(exports, "RatingsAndReviewsTrackingData", {
  enumerable: true,
  get: function () {
    return _generic.TrackingData;
  }
});
Object.defineProperty(exports, "ReviewDisplay", {
  enumerable: true,
  get: function () {
    return _ReviewDisplay.ReviewDisplayWithTracking;
  }
});
Object.defineProperty(exports, "SummaryData", {
  enumerable: true,
  get: function () {
    return _RatingSummary.SummaryData;
  }
});
Object.defineProperty(exports, "getAggregateRatingStructuredData", {
  enumerable: true,
  get: function () {
    return _structuredData.getAggregateRatingStructuredData;
  }
});
Object.defineProperty(exports, "getReviewsStructuredData", {
  enumerable: true,
  get: function () {
    return _structuredData.getReviewsStructuredData;
  }
});
require("./css/main.css");
var _RatingSummary = require("./components/RatingSummary");
var _ReviewDisplay = require("./components/ReviewDisplay");
var _structuredData = require("./utils/structuredData");
var _generic = require("./types/generic");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyZXF1aXJlIiwiX1JhdGluZ1N1bW1hcnkiLCJfUmV2aWV3RGlzcGxheSIsIl9zdHJ1Y3R1cmVkRGF0YSIsIl9nZW5lcmljIl0sInNvdXJjZXMiOlsiLi4vc3JjL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBcIi4vY3NzL21haW4uc2Nzc1wiXG5cbmltcG9ydCB7XG4gIFJhdGluZ1N1bW1hcnlXaXRoVHJhY2tpbmcgYXMgUmF0aW5nU3VtbWFyeSxcbiAgU3VtbWFyeURhdGEsXG59IGZyb20gXCIuL2NvbXBvbmVudHMvUmF0aW5nU3VtbWFyeVwiXG5pbXBvcnQge1xuICBSZXZpZXdEaXNwbGF5V2l0aFRyYWNraW5nIGFzIFJldmlld0Rpc3BsYXksXG4gIFJhdGluZ1Jldmlld0RhdGEsXG59IGZyb20gXCIuL2NvbXBvbmVudHMvUmV2aWV3RGlzcGxheVwiXG5pbXBvcnQge1xuICBnZXRBZ2dyZWdhdGVSYXRpbmdTdHJ1Y3R1cmVkRGF0YSxcbiAgZ2V0UmV2aWV3c1N0cnVjdHVyZWREYXRhLFxufSBmcm9tIFwiLi91dGlscy9zdHJ1Y3R1cmVkRGF0YVwiXG5pbXBvcnQgeyBUcmFja2luZ0RhdGEgYXMgUmF0aW5nc0FuZFJldmlld3NUcmFja2luZ0RhdGEgfSBmcm9tIFwiLi90eXBlcy9nZW5lcmljXCJcblxuZXhwb3J0IHtcbiAgUmF0aW5nU3VtbWFyeSxcbiAgUmV2aWV3RGlzcGxheSxcbiAgU3VtbWFyeURhdGEsXG4gIFJhdGluZ1Jldmlld0RhdGEsXG4gIGdldEFnZ3JlZ2F0ZVJhdGluZ1N0cnVjdHVyZWREYXRhLFxuICBnZXRSZXZpZXdzU3RydWN0dXJlZERhdGEsXG4gIFJhdGluZ3NBbmRSZXZpZXdzVHJhY2tpbmdEYXRhLFxufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBQSxPQUFBO0FBRUEsSUFBQUMsY0FBQSxHQUFBRCxPQUFBO0FBSUEsSUFBQUUsY0FBQSxHQUFBRixPQUFBO0FBSUEsSUFBQUcsZUFBQSxHQUFBSCxPQUFBO0FBSUEsSUFBQUksUUFBQSxHQUFBSixPQUFBIiwiaWdub3JlTGlzdCI6W119